import { Button, Text } from "app/components";
import { boxShadow, colors, spacing } from "app/utils/theme";

import { get } from "lodash";
import styled from "styled-components";

const CardWrapper = styled.div`
  background: white;
  box-shadow: ${boxShadow.card};
  ${(p) =>
    p.darkMode &&
    `
    background: ${colors.darkModeInputBackground};
    box-shadow: none;
    border: 1px solid ${colors.darkModeLightBorder};
  `};
  margin: ${(p) => p.margin};
  border-radius: 10px;
  width: ${(p) => p.width || "fit-content"};
  ${(p) => p.stretchHeight && "align-self: stretch;"}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.s4} ${spacing.s4} 10px ${spacing.s4};
`;

const Content = styled.div`
  padding: ${(p) => p.padding};
`;

const Card = ({
  children,
  header,
  width,
  margin,
  padding = spacing.s4,
  onClick,
  darkMode = false,
  stretchHeight = false,
}) => (
  <CardWrapper
    width={width}
    margin={margin}
    onClick={onClick}
    stretchHeight={stretchHeight}
    darkMode={darkMode}
  >
    {header && <Header data={header} />}
    <Content padding={padding}>{children}</Content>
  </CardWrapper>
);

export default Card;

const Header = ({ data }) => {
  const { label, description } = data;

  const buttons = get(data, "buttons", []);

  return (
    <HeaderContainer>
      <div>
        {label && <Text data={{ text: label, fontStyle: "headingMd" }} />}
        {description && (
          <Text
            data={{
              text: description,
              color: "var(--grey7)",
              fontStyle: "bodySm",
              margin: "3px 0 0 0",
            }}
          />
        )}
      </div>
      {buttons.map((b, i) => (
        <Button key={i} data={b} />
      ))}
    </HeaderContainer>
  );
};
